<template>
  <div class="qrLogin">
    <div>
      <div
        style="
          height: 300px;
          overflow: hidden;
          text-align: center;
          padding-top: 12px;
        "
      >
        <div @click="loginD" style="margin-top: 15px; display: inline-block">
          <vue-qr
            v-if="loginUrl"
            backgroundColor="#fff"
            :text="loginUrl"
            :margin="0"
            :size="196"
            style="border: 1px solid #e2e2e2; padding: 16px"
          ></vue-qr>
        </div>
        <div style="font-size: 13px; padding: 7px 14px">
          <div>使用PLANTMATE APP</div>
          <div>扫码登录PLANTMATE商城</div>
        </div>
      </div>
      <div class="submitTip">
        {{ $t("login.agreePolicy")
        }}<a style="cursor: pointer" @click="$emit('userAgree')">{{
          $t("login.servicePolicy")
        }}</a
        ><a style="cursor: pointer" @click="$emit('privacyAgree')">{{
          $t("login.userPrivacyPolicy")
        }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import VueQr from "vue-qr/src/packages/vue-qr.vue";
import Cookies from "js-cookie";

export default {
  components: { VueQr },
  data() {
    return {
      loginUrl: "",
      timeVal: "",
    };
  },
  created() {
    this.loginD();
  },
  beforeDestroy() {
    clearInterval(this.timeVal);
  },
  methods: {
    loginD() {
      this.loginType = "4";
      this.$http
        .get(
          "/front/sysQrCode/getQrCodeInfo?qrCodePrefix=PLANTMATE-loginQrCode"
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.loginUrl = res.data;
            if (!this.timeVal) {
              this.appLogin();
            }
          }
        });
    },
    appLogin() {
      this.timeVal = setInterval(() => {
        console.log("appLogin");

        this.$http
          .post(`/auth/qrCodeLogin/${this.loginUrl}`)
          .then(({ data: res }) => {
            if (res.code === 0 && res.data) {
              clearInterval(this.timeVal);
              Cookies.set("access_token_shop", res.data.access_token);
              Cookies.set("username_shop", res.data.username);
              // 学习平台cookie登录共享
              Cookies.set("access_token_shop", res.data.access_token, {
                domain: location.origin.includes("plantmate.supcon.com")
                  ? ".supcon.com"
                  : ".plantmate.com",
              });
              Cookies.set("username_shop", res.data.username, {
                domain: location.origin.includes("plantmate.supcon.com")
                  ? ".supcon.com"
                  : ".plantmate.com",
              });
              this.bus.$emit("getUserMenuPerm");
              this.$message.success("登录成功");
              this.bus.$emit("hideLoginDialog");
              const redirectUrl = this.toRedirectUrl();
              if (redirectUrl) {
                setTimeout(() => {
                  window.location.href = redirectUrl;
                }, 300);
                return;
              } else {
                setTimeout(() => {
                  window.location.href = "/";
                }, 300);
              }
            }
          });
      }, 1000);
    },
    // 重定向地址
    toRedirectUrl() {
      const redirectUrl = sessionStorage.getItem("redirectUrl");
      if (redirectUrl) {
        sessionStorage.removeItem("redirectUrl");
        // window.location.href = redirectUrl
      }
      return redirectUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
.qrLogin {
  width: 100%;
  padding: 24px;
  .submitTip {
    font-family: AlibabaPuHuiTi;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    color: #666666;
    margin-top: 8px;
    ::v-deep .el-checkbox__label {
      font-size: 12px;
      line-height: 18px;
      text-align: center;
      color: #666666;
    }
    a {
      color: #2a54d1;
    }
  }
}
</style>
